import * as React from 'react';

const AirQualityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={22}
    height={22}
    overflow="visible"
    preserveAspectRatio="none"
    {...props}
  >
    <g>
      <defs>
        <pattern
          id="a"
          width="100%"
          height="100%"
          x="0%"
          y="0%"
          patternUnits="objectBoundingBox"
        >
          <image
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref="data:image/svg+xml;base64,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"
            width={401}
            height={401}
            transform="scale(.05486)"
            vectorEffect="non-scaling-stroke"
          />
        </pattern>
      </defs>
      <path
        d="M0 0h22v22H0V0Z"
        style={{
          stroke: '#8c8c8c',
          strokeWidth: 0,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          fill: 'url(#a)',
        }}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
export default AirQualityIcon;
